import Highcharts from "highcharts";
import "highcharts/highcharts-more";

export default {
  name: "ExecutiveDashboard",

  data: () => ({
    is_collapsed: true,

    executive_kpis: [
      {
        title: "Monthly Recurring Revenue",
        icon: "fa fa-usd",
        value: "R 1.67M",
        change: "+18.5%",
        change_status: "positive",
        subtext: "vs last quarter",
        footer: "ARR Projection: R 20.04M | Target: R 25M (80% to goal)",
        borderClass: "border-top border-4 border-dark"
      },
      {
        title: "Revenue Growth Rate",
        icon: "fa fa-line-chart",
        value: "24.3%",
        change: "+3.8%",
        change_status: "positive",
        subtext: "YoY acceleration",
        footer: "Industry Avg: 18% | Top Quartile: 30%",
        borderClass: "border-top border-4 border-dark"
      },
      {
        title: "Revenue per Employee",
        icon: "fa fa-users",
        value: "R 385K",
        change: "+12.4%",
        change_status: "positive",
        subtext: "efficiency gain",
        footer: "Target: R 500K (77% achieved) | Optimization potential: 23%",
        borderClass: "border-top border-4 border-dark"
      },
      {
        title: "Customer Acquisition Cost",
        icon: "fa fa-bullseye",
        value: "R 18.2K",
        change: "8.5%",
        change_status: "negative",
        subtext: "needs optimization",
        footer: "LTV/CAC Ratio: 4.2x | Target: 5x | Industry: 3.5x",
        borderClass: "border-top border-4 border-dark"
      },
      {
        title: "Net Revenue Retention",
        icon: "fa fa-bar-chart",
        value: "118%",
        change: "+5.2%",
        change_status: "positive",
        subtext: "excellent expansion",
        footer: "Churn: 3.2% | Expansion: 21.2% | World-class NRR",
        borderClass: "border-top border-4 border-dark"
      },
      {
        title: "Gross Margin",
        icon: "fa fa-bolt",
        value: "78.5%",
        change: "+2.3%",
        change_status: "positive",
        subtext: "margin expansion",
        footer: "SaaS Benchmark: 75% | Path to 82% by Series B",
        borderClass: "border-top border-4 border-dark"
      }
    ],

    products: [
      {
        name: "Proba Analytics",
        arr: "R 6.2M",
        customers: "128",
        status: "Healthy",
        badgeClass: "bg-success",
        progress: 85,
        insight: "Leading analytics platform in SA government sector"
      },
      {
        name: "Proba Workflows",
        arr: "R 5.8M",
        customers: "94",
        status: "Healthy",
        badgeClass: "bg-success",
        progress: 78,
        insight: "Strong cross-product integrations driving adoption"
      },
      {
        name: "Orcaa",
        arr: "R 3.9M",
        customers: "67",
        status: "Needs Focus",
        badgeClass: "bg-warning text-dark",
        progress: 62,
        insight: "High SMB churn — enterprise stabilization recommended"
      },
      {
        name: "EngageNet",
        arr: "2.4M",
        customers: "82",
        status: "Healthy",
        badgeClass: "bg-success",
        progress: 62,
        insight: "Fastest growing product - strong product-market fit"
      },
      {
        name: "ComplyOn",
        arr: "1.1M",
        customers: "43",
        status: "Needs Focus",
        badgeClass: "bg-warning text-dark",
        progress: 62,
        insight: "B-BBEE focus resonating well with enterprise customers"
      },
      {
        name: "X-Verdict",
        arr: "0.6M",
        customers: "18",
        status: "Early Stage",
        badgeClass: "bg-warning text-dark",
        progress: 62,
        insight: "High growth but small base - evaluating scale strategy"
      }
    ],

    initiatives: [
      {
        title: "Series B Fundraising",
        subtitle: "Target: R 120M • Timeline: Q2 2026",
        icon: "bi bi-bullseye",
        iconBg: "#eaf1ff",
        progress: 65,
        progressColor: "#0d6efd"
      },
      {
        title: "Regional Expansion (Kenya, Nigeria)",
        subtitle: "Revenue Target: R 5M by Q3 2026",
        icon: "bi bi-graph-up-arrow",
        iconBg: "#e9f8f1",
        progress: 40,
        progressColor: "#10b981"
      },
      {
        title: "Headcount Optimization",
        subtitle: "Target: 36–40 employees (from 52)",
        icon: "bi bi-lightning-charge-fill",
        iconBg: "#fff6e5",
        progress: 55,
        progressColor: "#f59e0b"
      },
      {
        title: "AI Integration Across Products",
        subtitle: "ML features in 4/6 products",
        icon: "bi bi-robot",
        iconBg: "#eef2ff",
        progress: 75,
        progressColor: "#3b82f6"
      }
    ],

    risks: [
      {
        title: "Runway Constraint",
        description: "14 months cash runway at current burn • Series B timing critical",
        level: "HIGH",
        badgeClass: "bg-danger bg-opacity-25 text-danger",
        cardClass: "border-start border-4 border-danger bg-light"
      },
      {
        title: "Team Burnout Risk",
        description: "82% utilization • 6 team members at risk • Affecting velocity",
        level: "HIGH",
        badgeClass: "bg-danger bg-opacity-25 text-danger",
        cardClass: "border-start border-4 border-danger bg-light"
      },
      {
        title: "Orcaa Churn Rate",
        description: "8.2% churn in SMB segment • Product-market fit concerns",
        level: "MEDIUM",
        badgeClass: "bg-warning bg-opacity-25 text-dark",
        cardClass: "border-start border-4 border-warning bg-light"
      },
      {
        title: "CAC Efficiency",
        description: "CAC increased 8.5% • Sales process optimization needed",
        level: "MEDIUM",
        badgeClass: "bg-warning bg-opacity-25 text-dark",
        cardClass: "border-start border-4 border-warning bg-light"
      }
    ],

    actions: [
      {
        timeline: "IMMEDIATE ACTION",
        title: "Resource Rebalancing",
        description:
          "Redistribute workload from 6 at-risk team members. Consider hiring 2–3 senior engineers or reduce scope for Orcaa v3.0.",
        bg: "#fce2e2",
        border: "#e63946"
      },
      {
        timeline: "THIS MONTH",
        title: "Orcaa Turnaround Strategy",
        description:
          "Focus on enterprise segment. Consider sunsetting SMB tier or partner channel. Target: Reduce churn to <5% by Q1 2026.",
        bg: "#fbd3a0",
        border: "#d89216"
      },
      {
        timeline: "THIS QUARTER",
        title: "Series B Preparation",
        description:
          "Finalize pitch deck with updated metrics. Engage 3–5 lead investors. Target close: Q2 2026 (R 120M at R 800M valuation).",
        bg: "#d7e9ff",
        border: "#1d72b8"
      }
    ]
  }),

  mounted() {
    const saved = localStorage.getItem("aic_one_my_apps_collapsed");
    this.is_collapsed = saved === "1";

    this.$nextTick(() => {
      this.renderCustomerGrowthChart();
      this.renderTeamRadarChart();
    });
  },

  methods: {
    toggle_collapse() {
      this.is_collapsed = !this.is_collapsed;
      localStorage.setItem(
        "aic_one_my_apps_collapsed",
        this.is_collapsed ? "1" : "0"
      );
    },

    /** ----------------------------
     * SHARED: Tooltip Builder (Codacy Safe)
     * ---------------------------- */
    buildSharedTooltip(points, label) {
      let html = `<b>${label}</b>`;
      points.forEach(p => {
        html += `<br/>${p.series.name}: ${p.y}`;
      });
      return html;
    },

    /** ----------------------------
     * SHARED: Base Chart Config
     * ---------------------------- */
    baseChartConfig() {
      return ({
        title: { text: "" },
        credits: { enabled: false },
        legend: { enabled: true }
      });
    },

    /** ----------------------------
     * CUSTOMER GROWTH CHART
     * ---------------------------- */
    renderCustomerGrowthChart() {
      const config = {
        ...this.baseChartConfig(),
        chart: { type: "area", spacingTop: 20 },
        xAxis: this.customerXAxis(),
        yAxis: this.customerYAxis(),
        tooltip: this.customerTooltip(),
        plotOptions: this.customerPlotOptions(),
        series: this.customerSeries(),
        custom: { buildSharedTooltip: this.buildSharedTooltip }
      };

      Highcharts.chart("customerGrowthChart", config);
    },

    /** ---- SMALL HELPERS BELOW ---- */

    customerXAxis() {
      return ({
        categories: [
          "Q1 2024", "Q2 2024", "Q3 2024", "Q4 2024",
          "Q1 2025", "Q2 2025", "Q3 2025", "Q4 2025"
        ],
        tickmarkPlacement: "on",
        labels: { style: { fontSize: "12px" } }
      });
    },

    customerYAxis() {
      return ({
        title: { text: "" },
        min: 250,
        max: 550,
        labels: {
          formatter() { return this.value; }
        }
      });
    },

    customerTooltip() {
      return ({
        shared: true,
        useHTML: true,
        formatter() {
          return this.series.chart.options.custom.buildSharedTooltip(this.points, this.x);
        }
      });
    },

    customerPlotOptions() {
      return ({
        area: { fillOpacity: 0.15 }
      });
    },

    customerSeries() {
      return [
        {
          name: "Total Customers",
          data: [285, 310, 348, 380, 415, 450, 485, 510],
          color: "#0d6efd",
          lineWidth: 3,
          marker: {
            radius: 5, fillColor: "#fff", lineWidth: 2, lineColor: "#0d6efd"
          }
        },
        {
          name: "Customer Lifetime Value (R)",
          data: [250, 295, 340, 365, 410, 445, 475, 505],
          type: "line",
          color: "#c9a227",
          dashStyle: "ShortDash",
          lineWidth: 3,
          marker: {
            radius: 5, fillColor: "#fff", lineWidth: 2, lineColor: "#c9a227"
          }
        }
      ];
    },

    /** ----------------------------
     * TEAM RADAR CHART
     * ---------------------------- */
    renderTeamRadarChart() {
      const config = this.baseChartConfig();

      config.chart = {
        polar: true,
        type: "area",
        spacingTop: 20
      };

      config.pane = { size: "80%" };

      config.xAxis = {
        categories: [
          "Sprint Velocity",
          "Code Quality",
          "Deployment Freq",
          "Bug Resolution",
          "Innovation",
          "Customer Sat"
        ],
        tickmarkPlacement: "on",
        lineWidth: 0,
        labels: { style: { fontSize: "12px" } }
      };

      config.yAxis = {
        min: 0,
        max: 100,
        gridLineInterpolation: "polygon",
        labels: {
          formatter() {
            return this.value;
          }
        }
      };

      config.tooltip = {
        useHTML: true,
        formatter() {
          return `<b>${this.series.name}</b><br/>${this.point.category}: ${this.y}`;
        }
      };

      config.series = [
        {
          name: "Current Quarter",
          data: [95, 88, 80, 92, 78, 85],
          pointPlacement: "on",
          color: "#0d6efd"
        },
        {
          name: "Previous Quarter",
          data: [82, 80, 75, 85, 70, 78],
          pointPlacement: "on",
          color: "#9aa6b8"
        }
      ];

      Highcharts.chart("teamRadarChart", config);
    }
  }
};
